var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('v-divider'), _c('v-list-item', {
    on: {
      "click": function click($event) {}
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('No Item')))])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }